import React, { useState } from "react"
import PropTypes from "prop-types"

import Button from "./Button"
import YouTubePlayer from "./YouTubePlayer"
import Lightbox from "./Lightbox"

const VideoButton = ({ label, videoUrl, thumbnail, ...rest }) => {
  const [showDialog, setShowDialog] = useState(false)

  const openLightbox = (e) => {
    e.preventDefault()
    setShowDialog(true)
  }
  const closeLightbox = () => setShowDialog(false)

  return (
    <>
      <Button
        as="button"
        type="button"
        play={true}
        onClick={(e) => openLightbox(e)}
        {...rest}
      >
        {label}
      </Button>
      <Lightbox show={showDialog} close={closeLightbox} ariaLabel={"Video"}>
        <YouTubePlayer
          url={videoUrl}
          autoplay={true}
          isPlaying={true}
          thumbnail={thumbnail}
        />
      </Lightbox>
    </>
  )
}

VideoButton.propTypes = {
  label: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  thumbnail: PropTypes.node.isRequired,
  source: PropTypes.string,
}

export default VideoButton
